import styled from 'styled-components';

import IconEdit from 'components/icons/edit';
import IconPlus from 'components/icons/plus';
import Picture from 'components/picture';
import { stylesForMaxLinesOfText } from 'utils/style/max-lines-text';

import { CONTAINER_PADDING, EXCLAMATION_ICON_MARGIN, IMAGE_BORDER_RADIUS } from './constants';
import { iconBtnCss } from './recent-order-card.styled';

const IMAGE_HEIGHT = '120px';
const MOBILE_IMAGE_HEIGHT = '90px';
const ExclamationIconSize = 1;
const CARD_WIDTH = '200px';
const MOBILE_CARD_WIDTH = '160px';

export const Container = styled.div<{ marginRight: string }>`
  border-radius: ${Styles.borderRadius};
  ${p => p.marginRight && `margin-right: ${p.marginRight}`};
  width: ${CARD_WIDTH};
  min-width: ${CARD_WIDTH};
  padding: ${CONTAINER_PADDING};
  background: ${Styles.color.cardBackground};
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.07);
  overflow: hidden;
  height: 100%;

  ${Styles.mobile`
    width: ${MOBILE_CARD_WIDTH};
    min-width: ${MOBILE_CARD_WIDTH};
  `}
`;

export const Image = styled.div<{ backgroundImageUrl: string; height?: string }>`
  border-radius: ${IMAGE_BORDER_RADIUS};
  width: 100%;
  height: ${({ height }) => height || IMAGE_HEIGHT};
  ${p => p.backgroundImageUrl && `background-image: url(${p.backgroundImageUrl})`};
  background-position: center 42%;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;

  ${Styles.mobile`
    height: ${MOBILE_IMAGE_HEIGHT};
  `}
`;

const NAME_FONT_SIZE = 0.937;

export const Name = styled.h4<{ isAvailable: boolean }>`
  text-align: center;
  margin: 0.7rem 0;
  color: ${p => (p.isAvailable ? Styles.color.black : Styles.color.grey.three)};
  ${stylesForMaxLinesOfText({ maxLines: 2, lineHeight: 1.2, fontSizeInRem: NAME_FONT_SIZE })}
  font-size: ${NAME_FONT_SIZE}rem;
`;

export const AddIcon = styled(IconPlus)`
  width: 13px;
  fill: ${Styles.color.primary};
  font-weight: ${Styles.fontWeight.heavy};
`;

export const EditIcon = styled(IconEdit)`
  width: 15px;
  fill: ${Styles.color.primary};
`;

export const IconBtn = styled.button`
  border: 1px solid;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  padding: 0;
  cursor: pointer;
  color: ${Styles.color.primary};
  margin: 0px 10px 5px;
  &[disabled] {
    background-color: ${Styles.color.grey.five};
    color: ${Styles.color.grey.three};
    border: 1px solid ${Styles.color.grey.three};
    cursor: not-allowed;
    svg {
      fill: ${Styles.color.grey.three};
    }
  }
  ${iconBtnCss}
`;

export const BtnContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 46px;
`;

export const NotAvailableText = styled.div`
  font-size: 1rem;
  color: ${Styles.color.grey.three};
  display: flex;
  padding: 3px 15px 5px;
  line-height: 1.2;

  ${Styles.mobile`
    padding: 0px;
  `}
`;

export const ExclamationIcon = styled.div`
  color: ${Styles.color.white};
  background-color: ${Styles.color.grey.three};
  height: ${ExclamationIconSize}rem;
  min-height: ${ExclamationIconSize}rem;
  width: ${ExclamationIconSize}rem;
  min-width: ${ExclamationIconSize}rem;
  font-size: 0.7rem;
  border-radius: 50%;
  margin: ${EXCLAMATION_ICON_MARGIN};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const IMAGE_MARGIN_WIDTH = 6;

export const ProductImg = styled(Picture)`
  position: absolute;
  width: calc(100% - ${IMAGE_MARGIN_WIDTH * 2}px);
  height: calc(100% - ${IMAGE_MARGIN_WIDTH}px);
  margin: ${IMAGE_MARGIN_WIDTH}px;
  border-radius: ${Styles.borderRadius};
`;

export const CardContent = styled.div`
  padding: 0.3rem 0.3rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - ${IMAGE_HEIGHT});

  ${Styles.mobile`
    height: calc(100% - ${MOBILE_IMAGE_HEIGHT});
  `}
`;

export const AddToCardBtn = styled(IconBtn)`
  height: unset;
  width: unset;
  border: 2px solid;
  border-radius: 99rem;
  font-size: 1rem;
  padding: 0.5rem 0.7rem;
  width: 90px;
  &[disabled] {
    border: 2px solid ${Styles.color.grey.three};
  }
  & svg {
    stroke-width: 1;
    stroke: ${Styles.color.primary};
  }
`;

export const AddToCardBtnText = styled.span`
  padding-left: 0.5rem;
  text-transform: uppercase;
  font-weight: ${Styles.fontWeight.heavy};
`;
